import { useRouterState } from '@tanstack/react-router'
import { useCallback, useSyncExternalStore } from 'react'

/**
 * **Die Seitenleiste schmal oder breit** (22.10.2026 – Nils: *„das Menü links sollte man einklappen
 * können … sonst ist das so breit schon an Menüs. Aber mit Symbolen, sodass man trotzdem klicken
 * könnte (mit Tooltips und Badges)"*).
 *
 * Nur am großen Bildschirm (ab `lg`); darunter ist die Leiste ohnehin eine Schublade.
 *
 * **Zwei Gedächtnisse:** eines für das Notizbuch – das bringt seine eigene Leiste mit und ist
 * deshalb von sich aus schmal, wie im Mockup – und eines für alles andere, von sich aus breit.
 * Wer im Notizbuch aufklappt, klappt nicht die Aufgabenansichten mit auf.
 */

const SCHLUESSEL = {
  notizbuch: 'netcon-work.nav-schmal.notizbuch',
  sonst: 'netcon-work.nav-schmal',
}
const VORGABE = { notizbuch: true, sonst: false }
const hoerer = new Set<() => void>()

function lesen(art: keyof typeof SCHLUESSEL): boolean {
  try {
    const w = localStorage.getItem(SCHLUESSEL[art])
    return w === null ? VORGABE[art] : w === '1'
  } catch {
    return VORGABE[art]
  }
}

export function useNavSchmal(): [boolean, (schmal: boolean) => void] {
  const pfad = useRouterState({ select: (s) => s.location.pathname })
  const art = pfad.startsWith('/notizbuch') ? 'notizbuch' : 'sonst'
  const schmal = useSyncExternalStore(
    (h) => {
      hoerer.add(h)
      return () => hoerer.delete(h)
    },
    () => lesen(art),
    () => VORGABE[art],
  )
  const setzen = useCallback(
    (wert: boolean) => {
      try {
        localStorage.setItem(SCHLUESSEL[art], wert ? '1' : '0')
      } catch {
        /* ohne Gedächtnis – gilt dann nur bis zum Neuladen nicht */
      }
      for (const h of hoerer) h()
    },
    [art],
  )
  return [schmal, setzen]
}
